enum ProgressPopUpStyles {
  NONE = 'none',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export { ProgressPopUpStyles };
